/* ============================================================
   House of Avinya — theme behaviour
   Sections: drawing layer, reveals, rails, daylight slider,
   pincode, rupee split, hero, capture, cart, saved.
   ============================================================ */
(function () {
'use strict';

const $  = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');

/* ---------- toast ---------- */
let tTimer;
function toast(msg) {
  const t = $('#toast'); if (!t) return;
  t.textContent = msg; t.classList.add('on');
  clearTimeout(tTimer); tTimer = setTimeout(() => t.classList.remove('on'), 2800);
}
window.avToast = toast;

/* ---------- panels ---------- */
const PANELS = { menu: '#navPanel', cart: '#cartPanel', search: '#searchPanel', filters: '#filterSheet' };
function openPanel(k) {
  const el = $(PANELS[k]); if (!el) return;
  Object.values(PANELS).forEach(s => { const p = $(s); if (p) p.classList.remove('on'); });
  el.classList.add('on');
  const sc = $('#scrim'); if (sc) sc.classList.add('on');
  document.body.style.overflow = 'hidden';
  if (k === 'search') setTimeout(() => { const q = $('#q'); if (q) q.focus(); }, 260);
}
function closeAll() {
  Object.values(PANELS).forEach(s => { const el = $(s); if (el) el.classList.remove('on'); });
  const sc = $('#scrim'); if (sc) sc.classList.remove('on');
  document.body.style.overflow = '';
}
addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

/* nine weave palettes — the drawn stand-in until photographs land */
const WEAVE_C = {
  kanjivaram:{field:'#7B2434',motif:'#D8BE8B',border:'#1E5B48',pallu:'#12463A'},
  banarasi:  {field:'#3A2352',motif:'#DFC48E',border:'#8A3B33',pallu:'#2A1840'},
  jamdani:   {field:'#F1E7D4',motif:'#B08D57',border:'#8A3B33',pallu:'#E3D2B4'},
  ajrakh:    {field:'#24364D',motif:'#E7DAC2',border:'#8A3B33',pallu:'#182636'},
  patola:    {field:'#8A2E2A',motif:'#F0E2C4',border:'#1E4A3C',pallu:'#6E211E'},
  bandhani:  {field:'#8A3B33',motif:'#F5EBD6',border:'#C9A24A',pallu:'#6E2A24'},
  chanderi:  {field:'#E7DCC6',motif:'#B08D57',border:'#5E6B4B',pallu:'#D6C7A6'},
  paithani:  {field:'#1E5B48',motif:'#D8BE8B',border:'#8A2E5A',pallu:'#14453A'},
  ikat:      {field:'#5E6B4B',motif:'#F0E4CA',border:'#8A3B33',pallu:'#4A5539'}
};
window.avWeaveColours = WEAVE_C;

let _u = 0;
const uid = () => 'x' + (++_u);

function defsFor(kind, id, c){
  const F=c.field, M=c.motif;
  const P_ = {
    kanjivaram:`<rect width="46" height="46" fill="${F}"/>
      <path d="M0 23h46M23 0v46" stroke="${M}" stroke-width=".7" opacity=".5"/>
      <path d="M23 17l4 6h-8z" fill="${M}" opacity=".85"/><circle cx="23" cy="27" r="1.6" fill="${M}" opacity=".7"/>`,
    banarasi:`<rect width="54" height="54" fill="${F}"/>
      <path d="M27 12c7 4 10 9 10 15s-4 11-10 15c-6-4-10-9-10-15s3-11 10-15z" fill="none" stroke="${M}" stroke-width="1.1" opacity=".9"/>
      <path d="M27 20c3 3 4 5 4 7s-1 5-4 7c-3-2-4-5-4-7s1-4 4-7z" fill="${M}" opacity=".55"/>
      <circle cx="4" cy="4" r="1.3" fill="${M}" opacity=".7"/><circle cx="50" cy="50" r="1.3" fill="${M}" opacity=".7"/>`,
    jamdani:`<rect width="44" height="44" fill="${F}"/>
      <path d="M22 8l6 8-6 8-6-8z" fill="none" stroke="${M}" stroke-width="1" opacity=".8"/>
      <path d="M22 14v9" stroke="${M}" stroke-width=".7" opacity=".6"/>
      <path d="M4 32l3 4-3 4-3-4zM40 32l3 4-3 4-3-4z" fill="${M}" opacity=".5"/>`,
    ajrakh:`<rect width="48" height="48" fill="${F}"/>
      <path d="M24 4l20 20-20 20L4 24z" fill="none" stroke="${M}" stroke-width="1.1" opacity=".9"/>
      <path d="M24 14l10 10-10 10-10-10z" fill="none" stroke="${M}" stroke-width=".8" opacity=".7"/>
      <circle cx="24" cy="24" r="2.4" fill="${M}" opacity=".85"/>
      <circle cx="0" cy="0" r="2" fill="${M}" opacity=".5"/><circle cx="48" cy="48" r="2" fill="${M}" opacity=".5"/>
      <circle cx="48" cy="0" r="2" fill="${M}" opacity=".5"/><circle cx="0" cy="48" r="2" fill="${M}" opacity=".5"/>`,
    patola:`<rect width="52" height="52" fill="${F}"/>
      <path d="M26 3l23 23-23 23L3 26z" fill="none" stroke="${M}" stroke-width="2" opacity=".85" filter="url(#bl${id})"/>
      <path d="M26 16l10 10-10 10-10-10z" fill="${M}" opacity=".55" filter="url(#bl${id})"/>
      <path d="M26 22l4 4-4 4-4-4z" fill="${F}" opacity=".9"/>`,
    bandhani:`<rect width="30" height="30" fill="${F}"/>
      <circle cx="8" cy="8" r="2.1" fill="${M}" opacity=".9"/><circle cx="22" cy="8" r="2.1" fill="${M}" opacity=".9"/>
      <circle cx="15" cy="15" r="2.4" fill="${M}"/><circle cx="8" cy="22" r="2.1" fill="${M}" opacity=".9"/>
      <circle cx="22" cy="22" r="2.1" fill="${M}" opacity=".9"/>`,
    chanderi:`<rect width="40" height="40" fill="${F}"/>
      <path d="M0 0v40M20 0v40" stroke="${M}" stroke-width=".45" opacity=".35"/>
      <path d="M10 18c3 1.6 4.4 3.4 4.4 5.4S13 27.4 10 29c-3-1.6-4.4-3.6-4.4-5.6S7 19.6 10 18z" fill="${M}" opacity=".75"/>
      <path d="M30 6c2.2 1.2 3.2 2.6 3.2 4s-1 2.8-3.2 4c-2.2-1.2-3.2-2.6-3.2-4s1-2.8 3.2-4z" fill="${M}" opacity=".55"/>`,
    paithani:`<rect width="50" height="50" fill="${F}"/>
      <path d="M25 10c8 5 12 10 12 15s-4 10-12 15c-8-5-12-10-12-15s4-10 12-15z" fill="none" stroke="${M}" stroke-width=".9" opacity=".65"/>
      <circle cx="25" cy="25" r="3.4" fill="${M}" opacity=".8"/>
      <path d="M25 4v6M25 40v6M4 25h6M40 25h6" stroke="${M}" stroke-width=".8" opacity=".5"/>`,
    ikat:`<rect width="46" height="46" fill="${F}"/>
      <path d="M-6 34L11 12l17 22 17-22" fill="none" stroke="${M}" stroke-width="4.4" opacity=".8" filter="url(#bl${id})"/>
      <path d="M-6 12L11 -10l17 22 17-22" fill="none" stroke="${M}" stroke-width="2" opacity=".45" filter="url(#bl${id})"/>`
  }[kind];
  const size = {kanjivaram:46,banarasi:54,jamdani:44,ajrakh:48,patola:52,bandhani:30,chanderi:40,paithani:50,ikat:46}[kind];
  return `<filter id="bl${id}" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="${kind==='patola'||kind==='ikat'?1.5:0}"/></filter>
  <pattern id="fp${id}" width="${size}" height="${size}" patternUnits="userSpaceOnUse">${P_}</pattern>
  <pattern id="bp${id}" width="26" height="26" patternUnits="userSpaceOnUse">
    <rect width="26" height="26" fill="${c.border}"/>
    <path d="M13 4l6 9-6 9-6-9z" fill="none" stroke="${c.motif}" stroke-width="1" opacity=".85"/>
    <path d="M0 0h26" stroke="${c.motif}" stroke-width=".5" opacity=".5"/></pattern>
  <pattern id="pp${id}" width="34" height="34" patternUnits="userSpaceOnUse">
    <rect width="34" height="34" fill="${c.pallu}"/>
    <path d="M17 3c6 4 9 8 9 12s-3 8-9 12c-6-4-9-8-9-12s3-8 9-12z" fill="none" stroke="${c.motif}" stroke-width="1.2" opacity=".9"/>
    <circle cx="17" cy="15" r="2.6" fill="${c.motif}" opacity=".8"/>
    <path d="M0 29h34" stroke="${c.motif}" stroke-width=".8" opacity=".55"/></pattern>
  <linearGradient id="sh${id}" x1="0" y1="0" x2="1" y2="0">
    <stop offset="0" stop-color="#000" stop-opacity=".20"/><stop offset=".18" stop-color="#fff" stop-opacity=".13"/>
    <stop offset=".46" stop-color="#000" stop-opacity=".10"/><stop offset=".70" stop-color="#fff" stop-opacity=".16"/>
    <stop offset="1" stop-color="#000" stop-opacity=".22"/></linearGradient>
  <pattern id="wf${id}" width="3" height="3" patternUnits="userSpaceOnUse">
    <path d="M0 0h3" stroke="#000" stroke-width=".5" opacity=".07"/>
    <path d="M0 0v3" stroke="#fff" stroke-width=".5" opacity=".05"/></pattern>`;
}

/* draws a flat-laid saree: body field, side border, pallu band */
function cloth(weave, W, H, hex, label, opt){
  opt = opt || {};
  const base = WEAVE_C[weave] || WEAVE_C.kanjivaram;
  let c = Object.assign({}, base);
  if(hex && !opt.trueColour) c.field = hex;
  if(hex && String(hex).toLowerCase() === String(base.border).toLowerCase()) c.border = base.pallu;
  if(opt.daylight) c = daylightC(c);
  const id = uid(), bw = Math.round(W*0.155), ph = Math.round(H*0.24);
  return `<svg viewBox="0 0 ${W} ${H}" width="100%" preserveAspectRatio="xMidYMid slice" role="img" aria-label="${label || 'saree'}">
  <defs>${defsFor(weave, id, c)}</defs>
  <rect width="${W}" height="${H}" fill="url(#fp${id})"/>
  <rect x="0" y="0" width="${bw}" height="${H}" fill="url(#bp${id})"/>
  <rect x="${W-bw*0.55}" y="0" width="${bw*0.55}" height="${H}" fill="url(#bp${id})"/>
  <rect x="0" y="${H-ph}" width="${W}" height="${ph}" fill="url(#pp${id})"/>
  <rect x="0" y="${H-ph-6}" width="${W}" height="3" fill="${c.motif}" opacity=".8"/>
  <rect x="${bw}" y="0" width="2" height="${H}" fill="${c.motif}" opacity=".7"/>
  <rect width="${W}" height="${H}" fill="url(#wf${id})"/>
  <rect width="${W}" height="${H}" fill="url(#sh${id})"/>
</svg>`;
}
function swatch(weave, size){
  const id = uid(), c = WEAVE_C[weave] || WEAVE_C.kanjivaram;
  return `<svg viewBox="0 0 ${size} ${size}" width="100%" height="100%" aria-hidden="true"><defs>${defsFor(weave,id,c)}</defs>
    <rect width="${size}" height="${size}" fill="url(#fp${id})"/><rect width="${size}" height="${size}" fill="url(#wf${id})"/></svg>`;
}

/* ============================================================
   Daylight simulation
   ------------------------------------------------------------
   The 5000K studio frame is the true colour. The daylight frame
   is what the same cloth does under ordinary house light: warmer,
   less saturated, a step flatter. Once real matched pairs exist
   this function is deleted and the slider reads two photographs.
   ============================================================ */
function _h2h(hex){
  const n = parseInt(hex.slice(1), 16);
  let r = (n>>16&255)/255, g = (n>>8&255)/255, b = (n&255)/255;
  const mx = Math.max(r,g,b), mn = Math.min(r,g,b), d = mx-mn;
  let h = 0, s = 0, l = (mx+mn)/2;
  if(d){
    s = l > .5 ? d/(2-mx-mn) : d/(mx+mn);
    h = mx === r ? ((g-b)/d + (g<b?6:0)) : mx === g ? ((b-r)/d + 2) : ((r-g)/d + 4);
    h *= 60;
  }
  return [h, s*100, l*100];
}
function _hsl2h(h, s, l){
  h = ((h%360)+360)%360; s = Math.max(0,Math.min(100,s))/100; l = Math.max(0,Math.min(100,l))/100;
  const c = (1-Math.abs(2*l-1))*s, x = c*(1-Math.abs((h/60)%2-1)), m = l-c/2;
  let r=0,g=0,b=0;
  if(h<60){r=c;g=x;} else if(h<120){r=x;g=c;} else if(h<180){g=c;b=x;}
  else if(h<240){g=x;b=c;} else if(h<300){r=x;b=c;} else {r=c;b=x;}
  const t = v => Math.round((v+m)*255).toString(16).padStart(2,'0');
  return '#' + t(r) + t(g) + t(b);
}
function daylightHex(hex){
  let [h,s,l] = _h2h(hex);
  h += (h > 200 || h < 22) ? 11 : -8;  /* everything drifts toward amber   */
  s *= 0.62;                            /* house light flattens saturation  */
  l = l * 0.90 + 7;                     /* shadows lift, contrast collapses */
  return _hsl2h(h, s, l);
}
const daylightC = c => { const o = {}; for(const k in c) o[k] = daylightHex(c[k]); return o; };

/* ============================================================
   Drape — the full-bleed rendering
   ------------------------------------------------------------
   A hanging length rather than a flat lay: vertical pleat
   shading, a pallu across the lower third, a border at the
   selvedge, and a vignette so type sits legibly on top.
   ============================================================ */
function drape(slug, W, H, opt){
  opt = opt || {};
  const base = WEAVE_C[slug] || WEAVE_C.kanjivaram;
  const c = opt.daylight ? daylightC(base) : Object.assign({}, base);
  const id = uid();
  const ph = Math.round(H * 0.30);        /* pallu depth   */
  const bw = Math.round(W * 0.085);       /* selvedge band */
  const fold = Math.round(W / 7);
  return `<svg viewBox="0 0 ${W} ${H}" width="100%" height="100%" preserveAspectRatio="xMidYMid slice"
    role="img" aria-label="${opt.label || 'cloth'}${opt.daylight?', in ordinary daylight':''}">
  <defs>${defsFor(slug, id, c)}
    <linearGradient id="fd${id}" x1="0" x2="1" y1="0" y2="0">
      <stop offset="0" stop-color="#000" stop-opacity=".38"/>
      <stop offset=".14" stop-color="#000" stop-opacity=".10"/>
      <stop offset=".33" stop-color="#fff" stop-opacity=".16"/>
      <stop offset=".52" stop-color="#000" stop-opacity=".06"/>
      <stop offset=".72" stop-color="#fff" stop-opacity=".13"/>
      <stop offset=".88" stop-color="#000" stop-opacity=".12"/>
      <stop offset="1" stop-color="#000" stop-opacity=".38"/>
    </linearGradient>
    <pattern id="fo${id}" width="${fold}" height="${H}" patternUnits="userSpaceOnUse">
      <rect width="${fold}" height="${H}" fill="url(#fd${id})"/>
    </pattern>
    <radialGradient id="vg${id}" cx=".5" cy=".42" r=".78">
      <stop offset=".45" stop-color="#000" stop-opacity="0"/>
      <stop offset="1" stop-color="#000" stop-opacity=".34"/>
    </radialGradient>
    <linearGradient id="dp${id}" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fff" stop-opacity=".10"/>
      <stop offset=".55" stop-color="#000" stop-opacity="0"/>
      <stop offset="1" stop-color="#000" stop-opacity=".26"/>
    </linearGradient>
  </defs>
  <rect width="${W}" height="${H}" fill="url(#fp${id})"/>
  <rect x="0" y="${H-ph}" width="${W}" height="${ph}" fill="url(#pp${id})"/>
  <rect x="0" y="${H-ph-5}" width="${W}" height="2" fill="${c.motif}" opacity=".75"/>
  <rect x="0" y="${H-ph+7}" width="${W}" height="1" fill="${c.motif}" opacity=".4"/>
  <rect x="0" y="0" width="${bw}" height="${H}" fill="url(#bp${id})"/>
  <rect x="${bw}" y="0" width="1.6" height="${H}" fill="${c.motif}" opacity=".7"/>
  <rect x="${W-bw*0.62}" y="0" width="${bw*0.62}" height="${H}" fill="url(#bp${id})"/>
  <rect width="${W}" height="${H}" fill="url(#wf${id})"/>
  <rect width="${W}" height="${H}" fill="url(#fo${id})"/>
  <rect width="${W}" height="${H}" fill="url(#dp${id})"/>
  <rect width="${W}" height="${H}" fill="url(#vg${id})"/>
</svg>`;
}


/* ------------------------------------------------------------
   Placeholder drawing
   Any box marked .cloth-ph is filled with a drawn rendering.
   A real photograph replaces it the moment one is uploaded —
   Liquid only prints .cloth-ph when the image is missing.
   ------------------------------------------------------------ */
function drawPlaceholders(root) {
  $$('.cloth-ph:not([data-drawn])', root).forEach(el => {
    const w = (el.dataset.weave || 'kanjivaram').toLowerCase();
    const W = parseInt(el.dataset.w || 600, 10), H = parseInt(el.dataset.h || 800, 10);
    const mode = el.dataset.mode || 'cloth';
    const day = el.dataset.daylight === 'true';
    const label = el.dataset.label || '';
    el.innerHTML =
      mode === 'swatch' ? swatch(w, Math.max(W, H))
    : mode === 'drape'  ? drape(w, W, H, { daylight: day, label: label })
    :                     cloth(w, W, H, el.dataset.colour || '', label, { daylight: day, trueColour: el.dataset.truecolour === 'true' });
    el.setAttribute('data-drawn', '1');
  });
}
window.avDraw = drawPlaceholders;

/* ------------------------------------------------------------
   Scroll reveal — never in the first screen, off under reduced motion
   ------------------------------------------------------------ */
let rvEls = [], rvTick = false;
function rvSweep() {
  rvTick = false;
  const fold = innerHeight * 0.94;
  rvEls = rvEls.filter(e => {
    if (e.getBoundingClientRect().top < fold) { e.classList.add('in'); return false; }
    return true;
  });
}
function rvQueue() { if (!rvTick) { rvTick = true; requestAnimationFrame(rvSweep); } }
function initReveals() {
  const els = $$('.rv:not([data-rv])');
  els.forEach(e => e.setAttribute('data-rv', '1'));
  if (REDUCED.matches || document.body.dataset.reveals === 'off') { els.forEach(e => e.classList.add('now')); return; }
  const fold = innerHeight - 40;
  els.forEach(e => {
    if (e.getBoundingClientRect().top < fold) e.classList.add('now');
    else rvEls.push(e);
  });
  addEventListener('scroll', rvQueue, { passive: true });
  addEventListener('resize', rvQueue);
  requestAnimationFrame(rvSweep);
}

/* ------------------------------------------------------------
   Rails — arrows on desktop, a fade while there is more to the right
   ------------------------------------------------------------ */
function initRails() {
  $$('[data-rail]').forEach(wrap => {
    if (wrap._rail) return;
    const rail = wrap.querySelector('.rail'); if (!rail) return;
    const prev = wrap.querySelector('.railbtn.prev'), next = wrap.querySelector('.railbtn.next');
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      wrap.classList.toggle('more', rail.scrollLeft < max);
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    };
    rail.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    wrap._railStep = () => Math.max(240, Math.round(rail.clientWidth * 0.78));
    wrap._rail = rail;
    sync();
  });
}
function railMove(btn, dir) {
  const wrap = btn.closest('[data-rail]');
  if (wrap && wrap._rail) wrap._rail.scrollBy({ left: dir * wrap._railStep(), behavior: REDUCED.matches ? 'auto' : 'smooth' });
}

/* ------------------------------------------------------------
   Daylight slider
   ------------------------------------------------------------ */
function initDayl() {
  $$('[data-dayl]').forEach(el => {
    if (el._wired) return; el._wired = true;
    const set = clientX => {
      const r = el.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, (clientX - r.left) / r.width * 100));
      el.style.setProperty('--x', pct.toFixed(1) + '%');
      el.setAttribute('aria-valuenow', Math.round(pct));
    };
    let down = false;
    el.addEventListener('pointerdown', e => { down = true; el.setPointerCapture(e.pointerId); set(e.clientX); e.preventDefault(); });
    el.addEventListener('pointermove', e => { if (down) set(e.clientX); });
    el.addEventListener('pointerup', e => { down = false; try { el.releasePointerCapture(e.pointerId); } catch (_) {} });
    el.addEventListener('pointercancel', () => { down = false; });
    el.addEventListener('keydown', e => {
      const now = +el.getAttribute('aria-valuenow') || 50;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        const v = Math.max(0, Math.min(100, now + (e.key === 'ArrowRight' ? 5 : -5)));
        el.style.setProperty('--x', v + '%'); el.setAttribute('aria-valuenow', v); e.preventDefault();
      }
      if (e.key === 'Home') { el.style.setProperty('--x', '0%'); el.setAttribute('aria-valuenow', 0); e.preventDefault(); }
      if (e.key === 'End') { el.style.setProperty('--x', '100%'); el.setAttribute('aria-valuenow', 100); e.preventDefault(); }
    });
  });
}

/* ------------------------------------------------------------
   Pincode to an arrival date
   Zones come from a theme setting, so operations can retune them
   without a developer. Dates are working dates, never a Sunday.
   ------------------------------------------------------------ */
function zones() {
  try { return JSON.parse(document.body.dataset.zones || '[]'); } catch (e) { return []; }
}
function zoneFor(pin) {
  const p3 = pin.slice(0, 3), p2 = pin.slice(0, 2);
  for (const z of zones()) {
    const pre = (z.prefixes || '').split(',').map(s => s.trim());
    if (pre.includes(p3) || pre.includes(p2)) return z;
  }
  return { name: document.body.dataset.zoneDefaultName || 'Rest of India',
           days: +(document.body.dataset.zoneDefaultDays || 5) };
}
function workingDate(days) {
  const t = new Date(Date.now() + days * 864e5);
  if (t.getDay() === 0) t.setDate(t.getDate() + 1);
  return t.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
}
function pinCheck(mod) {
  const input = $('[data-pin-input]', mod), out = $('[data-pin-out]', mod);
  const pin = (input.value || '').trim();
  if (!/^[1-9][0-9]{5}$/.test(pin)) {
    out.innerHTML = '<span class="bad">' + (mod.dataset.badMsg || 'That is not a six-digit Indian pincode.') + '</span>';
    return;
  }
  const z = zoneFor(pin), dispatch = +(document.body.dataset.dispatchDays || 2);
  out.innerHTML = 'Arriving <b>' + workingDate(z.days + dispatch) + '</b>'
    + '<span class="z">' + z.name + ' &middot; dispatched within ' + dispatch + ' days &middot; '
    + (mod.dataset.returnsNote || 'free returns for 10 days after it lands') + '</span>';
  try { localStorage.setItem('av_pin', pin); } catch (e) {}
}

/* ------------------------------------------------------------
   Cart
   ------------------------------------------------------------ */
const money = c => window.avMoneyFormat
  ? window.avMoneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/,
      (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }))
  : '₹' + Math.round(c / 100).toLocaleString('en-IN');

async function refreshCart(open) {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    renderCart(cart); badges(cart.item_count);
    if (open) openPanel('cart');
    return cart;
  } catch (e) { return null; }
}
function renderCart(cart) {
  const body = $('#cartBody'), foot = $('#cartFoot'); if (!body) return;
  if (!cart.item_count) {
    body.innerHTML = '<div class="empty" style="padding:40px 0"><h3 style="margin-bottom:8px">Your bag is empty</h3>'
      + '<p class="muted" style="font-size:14px">Nine weaves are in stock right now.</p>'
      + '<a class="btn ghost" href="/collections/all">Shop sarees</a></div>';
    foot.innerHTML = ''; return;
  }
  body.innerHTML = cart.items.map(l => {
    const img = l.image
      ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" style="width:100%;display:block">'
      : '<div class="cloth-ph" data-weave="' + (l.product_type || '').toLowerCase() + '" data-w="82" data-h="110"></div>';
    return '<div class="crow">'
      + '<a href="' + l.url + '" style="border:1px solid var(--line);overflow:hidden;display:block;height:110px">' + img + '</a>'
      + '<div><div style="font-family:var(--serif);font-size:17px">' + l.product_title + '</div>'
      + '<div class="muted" style="font-size:12.5px">' + (l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '') + '</div>'
      + '<div style="display:flex;align-items:center;gap:12px;margin-top:10px">'
      + '<span class="qty"><button data-cart-qty data-key="' + l.key + '" data-q="' + (l.quantity - 1) + '">−</button>'
      + '<span class="mono-n">' + l.quantity + '</span>'
      + '<button data-cart-qty data-key="' + l.key + '" data-q="' + (l.quantity + 1) + '">+</button></span>'
      + '<button class="link-u muted" style="font-size:12.5px" data-cart-qty data-key="' + l.key + '" data-q="0">Remove</button>'
      + '</div></div>'
      + '<div class="mono-n" style="text-align:right;font-family:var(--serif);font-size:17px">' + money(l.final_line_price) + '</div>'
      + '</div>';
  }).join('');
  foot.innerHTML = '<div class="ln mono-n" style="display:flex;justify-content:space-between;font-size:14px"><span>Subtotal</span><span>'
    + money(cart.total_price) + '</span></div>'
    + '<p class="muted" style="font-size:12.5px;margin:6px 0 12px">' + (document.body.dataset.cartNote || 'Shipping and taxes calculated at checkout.') + '</p>'
    + '<form action="/cart" method="post"><button class="btn gold wide" type="submit" name="checkout">Checkout</button></form>'
    + '<a class="btn ghost wide" style="margin-top:8px" href="/cart">View full bag</a>';
  drawPlaceholders(body);
}
function badges(count) {
  $$('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = !count; });
}

/* ------------------------------------------------------------
   Saved sarees
   ------------------------------------------------------------ */
const WKEY = 'av_saved';
const saved = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
const setSaved = a => { localStorage.setItem(WKEY, JSON.stringify(a)); paintSaved(); };
function paintSaved() {
  const s = saved();
  $$('[data-wish]').forEach(b => {
    const on = s.indexOf(b.dataset.wish) > -1;
    b.classList.toggle('on', on);
    if (b.dataset.wishLabel) b.textContent = on ? 'Saved' : 'Save';
  });
  $$('[data-wish-count]').forEach(el => { el.textContent = s.length; el.hidden = !s.length; });
  const grid = $('#savedGrid');
  if (grid) {
    $$('[data-saved-card]', grid).forEach(c => { c.hidden = s.indexOf(c.dataset.savedCard) === -1; });
    const any = $$('[data-saved-card]:not([hidden])', grid).length;
    const empty = $('#savedEmpty'); if (empty) empty.hidden = !!any;
  }
}

/* ------------------------------------------------------------
   Delegated events
   ------------------------------------------------------------ */
document.addEventListener('click', async e => {
  const t = e.target;

  const openBtn = t.closest('[data-open]');
  if (openBtn) { e.preventDefault(); openPanel(openBtn.dataset.open); return; }
  if (t.closest('[data-close]')) { e.preventDefault(); closeAll(); return; }

  const acc = t.closest('.acc button.h');
  if (acc) { acc.parentElement.classList.toggle('open'); return; }

  const rp = t.closest('[data-rail-prev]'); if (rp) { railMove(rp, -1); return; }
  const rn = t.closest('[data-rail-next]'); if (rn) { railMove(rn, 1); return; }

  const pc = t.closest('[data-pin-check]');
  if (pc) { e.preventDefault(); pinCheck(pc.closest('[data-pin]')); return; }

  const sp = t.closest('[data-split-toggle]');
  if (sp) {
    e.preventDefault();
    const panel = sp.parentElement.querySelector('[data-splitpanel]');
    const open = panel.classList.toggle('open');
    sp.setAttribute('aria-expanded', open);
    const cx = sp.querySelector('.cx'); if (cx) cx.style.transform = open ? 'rotate(45deg)' : '';
    return;
  }

  const wish = t.closest('[data-wish]');
  if (wish) {
    e.preventDefault();
    const id = wish.dataset.wish, s = saved(), i = s.indexOf(id);
    if (i > -1) s.splice(i, 1); else s.push(id);
    setSaved(s);
    toast(i > -1 ? 'Removed from your list' : 'Saved to your list');
    return;
  }

  const hero = t.closest('[data-hero-weave]');
  if (hero) { e.preventDefault(); heroTo(hero); return; }

  const qty = t.closest('[data-cart-qty]');
  if (qty) {
    e.preventDefault();
    const r = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: qty.dataset.key, quantity: +qty.dataset.q })
    });
    const cart = await r.json();
    renderCart(cart); badges(cart.item_count);
    if ($('[data-cart-page]')) location.reload();
    return;
  }

  const msg = t.closest('[data-toast]');
  if (msg) { e.preventDefault(); toast(msg.dataset.toast); return; }
});

/* enter submits the pincode */
document.addEventListener('keydown', e => {
  if (e.key !== 'Enter') return;
  const inp = e.target.closest('[data-pin-input]');
  if (inp) { e.preventDefault(); pinCheck(inp.closest('[data-pin]')); }
});

/* add to bag without leaving the page */
document.addEventListener('submit', async e => {
  const form = e.target.closest('form.av-add');
  if (!form) return;
  e.preventDefault();
  const btn = $('[type=submit]', form), label = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!res.ok) { const err = await res.json(); toast(err.description || 'That one could not be added'); }
    else {
      const item = await res.json();
      toast(item.product_title + ' added to your bag');
      await refreshCart(document.body.dataset.cartDrawer !== 'off');
    }
  } catch (err) { toast('Something went wrong. Try again.'); }
  if (btn) { btn.disabled = false; btn.textContent = label; }
});

/* ------------------------------------------------------------
   Hero — swapping the cloth behind the type
   ------------------------------------------------------------ */
function heroTo(chip) {
  const bg = $('#heroBg'); if (!bg) return;
  const slug = chip.dataset.heroWeave;
  const img = chip.dataset.heroImage;
  bg.style.opacity = '0';
  setTimeout(() => {
    bg.innerHTML = img
      ? '<div class="frame"><img src="' + img + '" alt="' + (chip.dataset.heroName || '') + ' cloth"></div>'
      : '<div class="frame"><div class="cloth-ph" data-weave="' + slug + '" data-mode="drape" data-w="1400" data-h="900" data-label="'
        + (chip.dataset.heroName || '') + ' cloth"></div></div>';
    drawPlaceholders(bg);
    bg.style.opacity = '1';
  }, REDUCED.matches ? 0 : 190);

  const cap = $('#heroCap'); if (cap && chip.dataset.heroCaption) cap.innerHTML = chip.dataset.heroCaption;
  const read = $('#heroRead');
  if (read && chip.dataset.heroUrl) { read.href = chip.dataset.heroUrl; read.textContent = 'Read about ' + chip.dataset.heroName; }

  $$('[data-hero-weave]').forEach(c => {
    const on = c === chip;
    c.classList.toggle('on', on);
    c.setAttribute('aria-selected', on);
    if (on && c.scrollIntoView) c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: REDUCED.matches ? 'auto' : 'smooth' });
  });

  const d = $('#dayl-home');
  if (d) {
    const a = d.querySelector('.a'), b = d.querySelector('.b');
    a.innerHTML = '<div class="frame"><div class="cloth-ph" data-weave="' + slug + '" data-mode="drape" data-w="640" data-h="800"></div></div>';
    b.innerHTML = '<div class="frame"><div class="cloth-ph" data-weave="' + slug + '" data-mode="drape" data-daylight="true" data-w="640" data-h="800"></div></div>';
    if (chip.dataset.heroImage) a.innerHTML = '<div class="frame"><img src="' + chip.dataset.heroImage + '" alt=""></div>';
    if (chip.dataset.heroDaylight) b.innerHTML = '<div class="frame"><img src="' + chip.dataset.heroDaylight + '" alt=""></div>';
    drawPlaceholders(d);
  }
}

/* ------------------------------------------------------------
   Product page
   ------------------------------------------------------------ */
function initProduct() {
  const root = $('[data-product]'); if (!root) return;
  const dataEl = $('#variantData'); if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const form = $('form.av-add', root); if (!form) return;
  const idField = $('[name=id]', form);
  const priceEl = $('[data-price]', root);
  const btn = $('[data-add-btn]', root);
  const stickyPrice = $('[data-sticky-price]');

  function pick() {
    const chosen = $$('[data-opt]', root).filter(b => b.classList.contains('on')).map(b => b.dataset.value);
    const v = data.find(x => x.options.every((o, i) => o === chosen[i])) || data[0];
    if (idField) idField.value = v.id;
    if (priceEl) priceEl.innerHTML = v.price_html;
    if (stickyPrice) stickyPrice.firstChild && (stickyPrice.firstChild.textContent = v.price_html);
    if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (btn.dataset.label || 'Add to bag') : 'Sold out'; }
    $$('[data-media-id]', root).forEach(f => {
      if (v.media_id && f.dataset.mediaId == v.media_id) f.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  }
  $$('[data-opt]', root).forEach(b => b.addEventListener('click', () => {
    $$('[data-opt="' + b.dataset.opt + '"]', root).forEach(x => x.classList.remove('on'));
    b.classList.add('on'); pick();
  }));
  pick();

  const bar = $('#stickyBuy'), anchor = $('[data-buy-row]', root);
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0))
      .observe(anchor);
  }
  try {
    const pin = localStorage.getItem('av_pin');
    const mod = $('[data-pin]', root);
    if (pin && mod) { $('[data-pin-input]', mod).value = pin; pinCheck(mod); }
  } catch (e) {}
}

/* ------------------------------------------------------------
   Predictive search
   ------------------------------------------------------------ */
function initSearch() {
  const q = $('#q'), out = $('#searchOut'); if (!q || out === null) return;
  const hint = out.innerHTML;
  let timer;
  q.addEventListener('input', () => {
    clearTimeout(timer);
    const term = q.value.trim();
    if (!term) { out.innerHTML = hint; return; }
    timer = setTimeout(async () => {
      try {
        const r = await fetch('/search/suggest?q=' + encodeURIComponent(term)
          + '&resources[type]=product,article,page&resources[limit]=8&section_id=predictive-search');
        out.innerHTML = await r.text();
        drawPlaceholders(out); paintSaved();
      } catch (e) {}
    }, 220);
  });
  $$('[data-qfill]').forEach(b => b.addEventListener('click', () => {
    q.value = b.dataset.qfill; q.dispatchEvent(new Event('input'));
  }));
}

/* ------------------------------------------------------------
   Boot
   ------------------------------------------------------------ */
function boot() {
  drawPlaceholders();
  paintSaved();
  initReveals();
  initRails();
  initDayl();
  initProduct();
  initSearch();
  if ($('#cartBody')) refreshCart(false);
}
document.addEventListener('DOMContentLoaded', boot);
document.addEventListener('shopify:section:load', boot);
})();
